import { RugbyIcon } from './RugbyIcon';

/**
 * author: Google
 * id 19489FCE-DD25-4670-BC6F-4FC3AF1E66D3
 * name rugby
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rugby.svg
 * tags
 * - Sport 
 */
export const RugbyBallIcon = RugbyIcon;
export default RugbyBallIcon